/** Refresh shared bank caches containing TC rows, leaving legacy-only views fresh.
 * For Media Devoted | Created By Ciro Autiero */
import type { QueryKey } from "@tanstack/react-query";
const TC = "tres-commas";
const BANK_ROOTS = new Set([
  "paths",
  "landers",
  "offers",
  "flows",
  "path-rules",
]);
function includesTc(platform: unknown): boolean {
  if (platform == null || platform === "all") return true;
  return Array.isArray(platform)
    ? platform.length === 0 || platform.includes(TC)
    : platform === TC;
}
export function isTcRestoreBankKey(key: QueryKey): boolean {
  if (key[0] === "bank-overview") {
    const scopedKind = ["flows", "flow", "search"].includes(String(key[1]));
    return includesTc(key[scopedKind ? 2 : 1]);
  }
  if (!BANK_ROOTS.has(String(key[0]))) return false;
  const params = key[2];
  const platform =
    params && typeof params === "object" && "platform" in params
      ? params.platform
      : undefined;
  return includesTc(platform);
}
